export default {
  list: [],
  lastUpdate: ''
}
